import {
  CardContent,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import GoBack from "../../components/GoBack";

function ViewArbitrator() {
  const { navigationData } = useLocation().state;
  const [responseData] = useState(navigationData);

  const availabilityDescriptions = [
    "0. No availability",
    "1. Restricted availability",
    "2. Limited availability",
    "3. Moderate availability",
    "4. Sufficient availability",
    "5. Total availability",
  ];

  const formattedDate = new Date(responseData.createdAt).toLocaleString();
  console.log(responseData.availabilityClass);
  return (
    <div>
      <div className="container">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2 className="component-title">Arbitrator</h2>
          <GoBack />
        </div>

        <div>
          <div variant="outlined" className="custom-card">
            <CardContent>
              <div className="card-header">
                <div className="card-sub-header">
                  <p>
                    Arbitrator ID :{" "}
                    <span className="sub-text">{responseData.pseudonym}</span>
                  </p>
                </div>
              </div>
              <TableContainer
                component={Paper}
                className="custom-table-container"
              >
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableBody>
                    <TableRow>
                      <TableCell>Availability Class</TableCell>
                      <TableCell>
                        <span className="sub-text">
                          {responseData.availabilityClass}
                        </span>
                      </TableCell>
                      <TableCell className="column-border">Category</TableCell>
                      <TableCell>
                        <span className="sub-text">
                          {responseData.category}
                        </span>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="column-border">
                        Created by{" "}
                      </TableCell>
                      <TableCell>
                        <span className="sub-text">
                          {responseData.createdBy}
                        </span>
                      </TableCell>
                      <TableCell className="column-border">
                        Created at
                      </TableCell>
                      <TableCell>
                        <span className="sub-text">{formattedDate}</span>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewArbitrator;
